import React, { Fragment, FunctionComponent } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';

const InvalidSchemeCodeError: FunctionComponent = () => {
  return (
    <Fragment>
      <Text className="error-description">We cannot process this request as your account type is invalid for this type of transaction.</Text>
      <Text className="error-description">Please visit your nearest Axis bank branch for more details. </Text>
    </Fragment>
  )
}

export default InvalidSchemeCodeError;
